module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center page"
  }, [(_vm.result && _vm.result.success) ? _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "weui_msg"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "weui-msg__opr-area"
  }, [_c('router-link', {
    staticClass: "item-btn btn-green",
    attrs: {
      "to": _vm.window.history.back()
    }
  }, [_vm._v("返回商城")])], 1)])]) : _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "weui_msg"
  }, [_vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "weui-msg__opr-area"
  }, [_c('a', {
    staticClass: "item-btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.refresh($event)
      }
    }
  }, [_vm._v("刷新")]), _vm._v(" "), _c('router-link', {
    staticClass: "item-btn btn-green",
    attrs: {
      "to": _vm.window.history.back()
    }
  }, [_vm._v("返回商城")])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui-msg__icon-area"
  }, [_c('i', {
    staticClass: "weui-icon-success weui-icon_msg"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui-msg__text-area"
  }, [_c('h2', {
    staticClass: "weui-msg__title"
  }, [_vm._v("购买完成")]), _vm._v(" "), _c('p', {
    staticClass: "weui-msg__desc"
  }, [_vm._v("完成信息:...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui-msg__icon-area"
  }, [_c('i', {
    staticClass: "weui-icon-info weui-icon_msg"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui-msg__text-area"
  }, [_c('h2', {
    staticClass: "weui-msg__title"
  }, [_vm._v("订单查询中...")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d40c3be","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/web/wechat/callback.vue
// module id = dG4B
// module chunks = 3